import React from 'react'
import AdmStudentTransportFee from '../../components/AdminTabs/AdminStudentTransportFee/AdmStudentTransportFee'

const StudentTransportFee = () => {
  return (
    <div>
      <AdmStudentTransportFee />
    </div>
  )
}

export default StudentTransportFee